import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeoutStorageService {

  storageKey = "idleTimeout";

  constructor() { }

 
  storeIdleTimeout(idleTimeout) {
    localStorage.setItem(this.storageKey, idleTimeout);
  }

 
  loadIdleTimeout() {
    return localStorage.getItem(this.storageKey);
  }


  clear() {
    localStorage.removeItem(this.storageKey);
  }
}
